import React from "react";
import TargetedTalent from "../../assets/images/recruiting/targeted-talent.svg";
import AutoCandNurturing from "../../assets/images/recruiting/automated-candidate-nurturing.svg";
import SeamlessInte from "../../assets/images/recruiting/seamlessInte.svg";
import CompreCanProf from "../../assets/images/recruiting/comprehensiveCandidateProfiles.svg";
import EffiInterSchedule from "../../assets/images/recruiting/effieientInterSche.svg";
import CollabAndComms from "../../assets/images/recruiting/colabAndComms.svg";

const features = [
  {
    title: "Targeted Talent Sourcing",
    desc: "BeyondLeadz enables you to build and manage talent pools based on specific skills, experience, and qualifications. Use advanced search and filtering options to identify the best candidates for your open positions.",
    img: TargetedTalent,
  },
  {
    title: "Automated Candidate Nurturing",
    desc: "Keep candidates engaged with automated follow-ups and personalized communications. BeyondLeadz allows you to set up workflows that nurture talent throughout the recruitment process, ensuring that top candidates remain interested and informed.",
    img: AutoCandNurturing,
  },
  {
    title: "Seamless Integration with Job Portals",
    desc: "Integrate BeyondLeadz with popular job boards, LinkedIn, and your company’s career page to capture candidate information directly into your system. This ensures a consistent flow of talent into your recruitment pipeline.",
    img: SeamlessInte,
  },
  {
    title: "Comprehensive Candidate Profiles",
    desc: "Enrich candidate data with additional information such as previous job history, education, certifications, and more. This helps you get a fuller understanding of each candidate, allowing for better decision-making.",
    img: CompreCanProf,
  },
  {
    title: "Efficient Interview Scheduling",
    desc: "Streamline the interview scheduling process with automated calendar integrations. BeyondLeadz allows candidates to choose available slots that work best for them, reducing back-and-forth communication and speeding up the recruitment process.",
    img: EffiInterSchedule,
  },
  {
    title: "Collaboration and Communication",
    desc: "BeyondLeadz makes it easy for HR teams to collaborate on candidate evaluations, share notes, and track progress. Keep everyone on the same page with real-time updates and a centralized system for all recruitment activities.",
    img: CollabAndComms,
  },
];

const FeaturesList = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-5xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Section Header */}
        <div className="tw-text-center tw-mb-20">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            Recruit Smart, Hire Fast
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Why HR and Recruitment Teams <br />
            Should Use <span className="tw-text-[#5D44FF]">BeyondLeadz</span>
          </h2>
        </div>

        {/* Alternating Layout Blocks */}
        <div className="tw-space-y-12">
          {features.map((item, idx) => {
            const isEven = idx % 2 === 0;
            return (
              <div
                key={idx}
                className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-[32px] tw-p-8 sm:tw-p-10 tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-300"
              >
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-8 tw-items-center">
                  
                  {/* Text Container */}
                  <div className={`md:tw-col-span-7 tw-text-left ${isEven ? "md:tw-order-1" : "md:tw-order-2"}`}>
                    <h3 className="tw-text-lg sm:tw-text-xl tw-font-extrabold tw-text-slate-800 tw-mb-4">
                      {item.title}
                    </h3>
                    <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                      {item.desc}
                    </p>
                  </div>

                  {/* Image Container */}
                  <div className={`md:tw-col-span-5 tw-flex tw-justify-center ${isEven ? "md:tw-order-2" : "md:tw-order-1"}`}>
                    <div className="tw-overflow-hidden tw-rounded-2xl hover:tw-scale-[1.03] tw-transition-transform tw-duration-300 tw-h-20 tw-flex tw-items-center">
                      <img
                        src={item.img}
                        alt={item.title}
                        className="tw-h-full tw-w-auto tw-object-contain"
                        loading="lazy"
                      />
                    </div>
                  </div>

                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default FeaturesList;
